import { createFileRoute } from '@tanstack/react-router';
import { EventRequestReviewPage } from '../../features/event-requests/EventRequestReviewPage.jsx';

function EventRequestRoute() {
  const { eventId } = Route.useParams();
  return <EventRequestReviewPage key={eventId} eventId={eventId} />;
}

export const Route = createFileRoute('/_app/event-requests/$eventId')({ component: EventRequestRoute });
